export default __webpack_public_path__ + "static/media/ic_percentage_active.35c498d9.svg";